export default {
    // Profiles
    driverPerformanceConfig_riskEvents_profiles: "Profiles",
    // Category
    driverPerformanceConfig_riskEvents_category: "Category",
    driverPerformanceConfig_riskEvents_eventName: "Event Name",
    driverPerformanceConfig_riskEvents_status: "Status",
    driverPerformanceConfig_riskEvents_inactive: "Inactive",
    driverPerformanceConfig_riskEvents_active: "Active",
    // Risk Events
    driverPerformanceConfig_riskEvents_severityMappingTooltip: "Allows you to set the scales for the event risk values.",
    driverPerformanceConfig_riskEvents_coachableTooltip: "Enable this event for the coaching module.",
    driverPerformanceConfig_riskEvents: "Risk Events",
    driverPerformanceConfig_riskEvents_save: "Save",
    driverPerformanceConfig_riskEvents_cancel: "Cancel",
    driverPerformanceConfig_riskEvents_severityMapping: "Severity Mapping",
    driverPerformanceConfig_riskEvents_start: "Start",
    driverPerformanceConfig_riskEvents_low: "Low",
    driverPerformanceConfig_riskEvents_medium: "Medium",
    driverPerformanceConfig_riskEvents_high: "High",
    driverPerformanceConfig_riskEvents_critical: "Critical",
    driverPerformanceConfig_riskEvents_edit: "Edit",
    driverPerformanceConfig_riskEvents_coachable: "Coachable",
    driverPerformanceConfig_riskEvents_absolute: "Absolute",
    driverPerformanceConfig_riskEvents_relative: "Relative",
    driverPerformanceConfig_riskEvents_eventCreatedSuccessfully: "Event created successfully.",
    driverPerformanceConfig_riskEvents_eventUpdatedSuccessfully: "Event updated successfully.",
    driverPerformanceConfig_riskEvents_eventDeletedSuccessfully: "Event deleted successfully.",

    // Category translations
    driverPerformanceConfig_riskEvents_category_aggression: 'Aggression',
    driverPerformanceConfig_riskEvents_category_adas: 'ADAS',
    driverPerformanceConfig_riskEvents_category_dms: 'DMS',

    //Modal no save changes
    driverPerformanceConfig_riskEvents_modalNoSaveChanges_title: "Remember to save changes",
    driverPerformanceConfig_riskEvents_modalNoSaveChanges_content: "If you want to lose the adjustments, click Accept. Otherwise, click Cancel to return to the screen and be able to save the changes.",
    driverPerformanceConfig_riskEvents_modalNoSaveChanges_accept: "Accept",
    driverPerformanceConfig_riskEvents_modalNoSaveChanges_cancel: "Cancel",
};